import Vue from 'vue'
import VueResource from 'vue-resource'
import { config } from '../config/config'

Vue.use(VueResource)
Vue.http.options.root = config.apiRoot

// let trace = !!(window.initData.debugMode & (1 << 0))
// let enableTrace = trace ? '&enableTrace=true' : ''

export const BookingResource = Vue.resource({}, {}, {
  getBookingData: {method: 'POST', url: 'plantours/resources'},
  doBookingAction: { method: 'POST', url: 'plantours/booking/doBookingAction' },
  getInsuranceData: {method: 'POST', url: 'plantours/resources/insurances' },
}, {
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
})
